<template>
  <task-tree ref="taskTree" @click="handleClickTask" noNav>
    <transition name='fade' mode='out-in'>
      <div v-if="showData">
        <base-header
          v-bind="dataHeaders"
          @handleBack="handleClickBack"
        />
        <base-form
          v-bind="dataForm"
        />
      </div>
      <div v-else>
        <base-header
          v-bind="headers"
          @handleUpdate="handleUpdate"
          @handleCollect="handleCollect"
          @handleMove="handleMove"
          @handleDeleteData="handleDeleteData"
          @handleClear="handleClear"
          @handleDeleteTask="handleDeleteTask"
          @handleExport="handleExport"
        />
        <base-table
          v-bind="list"
          @handleSelectionChange="handleSelectionChange"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          @handleDetail="handleDetail"
        />
      </div>
    </transition>
    <form-dialog
      ref="addDialog"
      v-bind="moveForm"
      :options="{
        columnOptions,
        contentModelOptions
      }"
      @handleConfirm="handleConfirmAdd"
    ></form-dialog>
    <fast-dialog
      ref="fast"
      v-bind="detail"
      :Update="true"
      :defaultForm="detail"
    />
  </task-tree>
</template>
<script>
import TaskTree from './TaskTree'
import FastDialog from './FastDialog'
import baseHeader from '@/components/mixins/baseHeader'
import baseTable from '@/components/mixins/baseTable'
import formDialog from '@/components/mixins/formDialog'
import baseForm from '@/components/mixins/baseForm'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'interactCollectDetail',
  mixins: [baseHeader, baseTable, formDialog, baseForm],
  components: {
    TaskTree,
    FastDialog
  },
  data () {
    return {
      showData: false,
      dataHeaders: {
        showAlertIcon: false,
        buttons: [
          {
            type: 'Back',
            text: '返回',
            icon: 'fanhui'
          }
        ]
      },
      headers: {
        content: '这里是任务数据列表',
        buttons: [
          {
            type: 'Update',
            text: '修改任务',
            icon: 'xiugaihuifu'
          },
          {
            type: 'Collect',
            text: '开始采集',
            icon: 'kaishicaiji'
          },
          {
            type: 'Move',
            text: '移动数据',
            icon: 'yidong1'
          },
          {
            type: 'DeleteData',
            text: '删除数据',
            icon: 'delete'
          },
          {
            type: 'Clear',
            text: '清空所有数据',
            icon: 'qingkong'
          },
          {
            type: 'DeleteTask',
            text: '删除任务',
            icon: 'delete'
          },
          {
            type: 'Export',
            text: '导出数据',
            icon: 'daochu-tianchong'
          }
        ]
      },
      list: {
        api: 'fetchCollectContentPage',
        params: {
          taskId: ''
        },
        columns: []
      },
      moveForm: {
        loading: false,
        title: '移动数据',
        form: {
          channelId: '',
          modelId: ''
        },
        formItems: [
          {
            prop: 'modelId',
            label: '选择内容模型',
            type: 'select',
            options: 'contentModelOptions',
            popoverText: '若所选的内容模型中不包含所选字段，则不保存该字段'
          },
          {
            prop: 'channelId',
            label: '移动到',
            type: 'selectTree',
            options: 'columnOptions'
          }
        ],
        buttons: [
          {
            text: '确定',
            type: 'Submit'
          }
        ]
      },
      dataDetail: {},
      detail: {},
      templateId: '',
      collectType: '',
      taskForm: {
        id: '',
        name: '',
        keyword: '',
        fieldIds: [],
        dataPosition: 1,
        channelId: '',
        modelId: '',
        modelType: ''
      }
    }
  },
  computed: {
    ...mapGetters(['columnOptions', 'contentModelOptions']),
    taskId () {
      return this.list.params.taskId
    },
    dataForm () {
      return {
        showSubmitButton: false,
        labelWidth: 'auto',
        form: this.dataDetail,
        formItems: this.list.columns.map(d => ({
          prop: d.prop,
          label: d.label + '：',
          type: 'text'
        }))
      }
    }
  },
  methods: {
    ...mapActions('column', ['FetchColumnOptions']),
    ...mapActions('content', ['FetchContentModeList']),
    ...mapActions('interact', ['FetchCollectTaskList']),
    handleClickBack () {
      this.showData = false
    },
    handleDetail (row, index) {
      this.dataDetail = row
      this.showData = true
    },
    // 选择任务
    handleClickTask (data) {
      this.list.params.taskId = data.id
      this.fetchTableApi()
      this.fetchCollectTaskDetail()
    },
    // 更新
    handleUpdate () {
      this.$refs.fast.showDialog()
    },
    // 采集
    handleCollect () {
      this.$request.fetchCollectStart({ id: this.taskId }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '后台开始采集',
            type: 'success'
          })
        }
      })
    },
    // 移动
    handleMove () {
      if (this.list.selectedKeys.length) {
        this.$refs.addDialog.showDialog()
      } else {
        this.$message('至少选择一项进行操作')
      }
    },
    handleConfirmAdd (data, btn) {
      this.addFormLoading = true
      data.collectContentIds = this.list.selectedKeys
      this.$request.fetchCollectContentMove(data).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '移动成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
        this.addFormLoading = false
      }).catch(() => {
        this.addFormLoading = false
      })
    },
    // 删除数据
    handleDeleteData () {
      if (this.list.selectedKeys.length) {
        this.$confirm('是否确定批量删除数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fetchCollectContent()
        })
      } else {
        this.$message('至少选择一项进行操作')
      }
    },
    fetchCollectContent () {
      this.list.loading = true
      this.$request.fetchCollectContent({ ids: this.list.selectedKeys }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 清空
    handleClear () {
      this.$confirm('是否确定清空数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchCollectContentAll()
      })
    },
    fetchCollectContentAll () {
      this.list.loading = true
      this.$request.fetchCollectContentAll({ taskId: this.taskId }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.fetchTableApi()
        }
      }).then(this.hideTableLoading).catch(this.hideTableLoading)
    },
    // 删除任务
    handleDeleteTask () {
      this.$confirm('是否确定删除任务？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.fetchCollectTaskDelete()
      })
    },
    fetchCollectTaskDelete () {
      this.$request.fetchCollectTaskDelete({ id: this.taskId }).then(res => {
        if (res.code === 200) {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.list.data = []
          this.detail = {}
          this.FetchCollectTaskList(true)
        }
      })
    },
    // 导出
    handleExport () {
      this.$request.fetchCollectContentExport({ taskId: this.taskId }).then(res => {
        this.$exportClick(res, '采集数据.xls')
      })
    },
    // 请求任务详情数据，还需要任务类型和模板ID以及任务详情
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.columns = res.data.title.map((d, i) => {
          d.prop = d.field
          if (i === 0) {
            d.scopeType = 'handle'
            d.type = 'Detail'
          }
          return d
        })
        this.list.data = res.data.content
        this.list.totalCount = res.data.totalElements
        this.templateId = res.data.templateId
        this.collectType = res.data.type
        Object.keys(this.taskForm).forEach(k => {
          if (k in res.data) {
            this.taskForm[k] = res.data[k]
          }
        })
      }
    },
    // 请求详情
    fetchCollectTaskDetail () {
      this.$request.fetchCollectTaskDetail(this.taskId).then(res => {
        if (res.code === 200) {
          this.detail = res.data
        }
      })
    }
  },
  mounted () {
    const { id } = this.$route.query
    if (id) {
      this.list.params.taskId = Number(id)
      this.fetchCollectTaskDetail()
      this.$refs.taskTree.setCurrentNodeKey(Number(id))
    }
    this.FetchColumnOptions()
    this.FetchContentModeList()
  }
}
</script>
<style lang="scss">

</style>
